import { Injectable } from '@angular/core';

export interface ContactFormData {
  name: string;
  email: string;
  phone: string;
  subject: string;
  message: string;
}

@Injectable({
  providedIn: 'root'
})
export class ContactService {
  private readonly recipientEmail = 'alosailimu@waseel.com';

  constructor() {}

  sendContactForm(formData: ContactFormData): void {
    // Directly open email client - no external service needed
    this.openEmailClient(formData);
  }

  // Fallback method - opens email client
  openEmailClient(formData: ContactFormData): void {
    const subject = encodeURIComponent(`Contact Form: ${formData.subject}`);
    const body = encodeURIComponent(this.generateEmailBody(formData));
    
    const mailtoLink = `mailto:${this.recipientEmail}?subject=${subject}&body=${body}`;
    
    // Open user's default email client
    window.open(mailtoLink, '_self');
  }

  private generateEmailBody(formData: ContactFormData): string {
    return `Hello,

I am contacting you through the Insurance Aggregator website.

Contact Information:
Name: ${formData.name}
Email: ${formData.email}
Phone: ${formData.phone}
Subject: ${formData.subject}

Message:
${formData.message}

---
This email was sent from the Insurance Aggregator contact form.
Submitted on: ${new Date().toLocaleString()}`;
  }
}